"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabCarousel;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intentsConfig = _interopRequireDefault(require("../../page-body/media-components/tab-carousel-section/intents.config.js"));
var _tabCarouselItem = _interopRequireDefault(require("./tab-carousel-item"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TabCarouselContainer = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "TabCarouselContainer",
  class: "pl-ttbteqw"
});
const TabsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TabsContainer",
  class: "pl-t1qn726w"
});
const Tab = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "Tab",
  class: "pl-t17u936k",
  vars: {
    "t17u936k-0": [({
      active
    }) => active ? `${_intentsConfig.default.uxTabs.itemHovered.foregroundColor}` : `${_intentsConfig.default.uxTabs.item.foregroundColor}`],
    "t17u936k-1": [({
      active
    }) => active ? `var(--active-tab-border-width) ${_intentsConfig.default.ux.figure.figureColor0}` : '0'],
    "t17u936k-3": [({
      active
    }) => active ? `2.25rem ${_patternLibraryUtils.density['3']}` : `calc(2.25rem + (var(--active-tab-border-width) - var(--inactive-tab-border-width))) ${_patternLibraryUtils.density['3']}`]
  }
});
const FeatureContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FeatureContainer",
  class: "pl-fy1icp2"
});

/**
 * TabCarousel Component
 * @module TabCarousel
 *
 * @param {object} props React props
 * @param {heading} props.heading Heading text
 * @param {array} props.items Array of Tab Carousel Items
 * @param {boolean} props.slideAnimation True to use slide animation, false to use fade in
 * @returns {React.ReactElement} TabCarouselSection Component
 * @public
 */
function TabCarousel({
  items,
  heading,
  slideAnimation = false
}) {
  const [activeTabIndex, setActiveTabIndex] = (0, _react.useState)(0);
  return /*#__PURE__*/_react.default.createElement(TabCarouselContainer, {
    "data-cy": "tab-carousel-section",
    className: "fs-unmask"
  }, heading, /*#__PURE__*/_react.default.createElement(TabsContainer, {
    role: "tablist",
    tabsCount: items.length
  }, items?.map(({
    tabTitle,
    ariaLabel
  }, i) => /*#__PURE__*/_react.default.createElement(Tab, {
    key: i,
    role: "tab",
    "aria-label": ariaLabel || tabTitle,
    "data-cy": "tab",
    active: i === activeTabIndex,
    onClick: () => setActiveTabIndex(i)
  }, tabTitle))), /*#__PURE__*/_react.default.createElement(FeatureContainer, null, items?.map((item, i) => /*#__PURE__*/_react.default.createElement(_tabCarouselItem.default, (0, _extends2.default)({
    key: i,
    active: i === activeTabIndex,
    slideAnimation: slideAnimation
  }, item)))));
}
TabCarousel.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_tabCarouselItem.default.propTypes)),
  heading: _propTypes.default.node,
  slideAnimation: _propTypes.default.bool
};